import React from 'react';
import { parseSalesPerson } from '../../../services/helpers/sales-person.helper';

export interface SalesPersonCardProps {
  data: {
    salesPerson?: string;
  };
  className?: string;
}

const Field = ({ label, value }: { label: string; value?: string }) => (
  <div className="rounded-lg border border-gray-100 bg-white/80 p-3 min-w-0">
    <span className="block text-sm font-gilroy-medium text-neutral-500 uppercase tracking-wide mb-1">
      {label}
    </span>
    <span
      className={`block text-xl truncate ${
        value ? 'text-gray-800 font-gilroy-bold' : 'text-gray-300 font-gilroy-medium'
      }`}
      title={value}
    >
      {value || '—'}
    </span>
  </div>
);

/**
 * Who on the sales team owns this reservation. Always rendered, "Unassigned" included:
 * a reservation with nobody on it is exactly the one someone needs to notice.
 */
export const SalesPersonCard: React.FC<SalesPersonCardProps> = ({ data, className = '' }) => {
  const salesPerson = parseSalesPerson(data.salesPerson);

  return (
    <div
      className={`bg-white rounded-lg shadow-sm bg-gradient-to-b from-sky-50/70 to-white p-5 ${className}`}
    >
      <div className="flex items-center justify-between gap-3 mb-4 pb-3 border-b border-gray-100">
        <p className="text-sm text-sky-600 font-gilroy-bold leading-tight uppercase tracking-wide">
          Sales person
        </p>
        {!salesPerson && (
          <span className="rounded-full border border-gray-200 bg-gray-50 px-2.5 py-0.5 text-xs font-gilroy-bold text-gray-500">
            Unassigned
          </span>
        )}
      </div>

      {salesPerson ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <Field label="Name" value={salesPerson.name} />
          <Field label="Email" value={salesPerson.email} />
        </div>
      ) : (
        <p className="text-sm font-gilroy-medium text-gray-400 m-0">
          No sales person is assigned to this reservation
        </p>
      )}
    </div>
  );
};

export default SalesPersonCard;
